import styled from "@emotion/styled";
import React from "react";
import {observer} from "mobx-react";
import {Container} from "@mui/material";
import {NavLink} from "react-router-dom";
import logoIcon from "assets/img/logo_with_sponsor.svg";

const HeaderWrapper = styled.div`
	background: #ffffff;
	border-bottom: 1px solid #d6d4d2;
`;

const HeaderContent = styled.div`
	gap: 12px;
	height: 50px;

	@media (min-width: 768px) {
		padding: 10px 20px;
	}
`;

const SubHeader = styled(Container)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	background: #ffffff;
	height: 50px;
`;

export const OffSeasonHeader: React.FC = observer(() => {
	return (
		<HeaderWrapper>
			<HeaderContent className="flex items-center">
				<SubHeader>
					<NavLink to={"/"}>
						<img className="h-10 w-auto" src={logoIcon} alt="Fantasy golf" />
					</NavLink>
				</SubHeader>
			</HeaderContent>
		</HeaderWrapper>
	);
});
